import { serverNowFrom } from '../services/authService';

export const nafathResendLockSeconds = (resp, fallbackSeconds) => {
	const expiresAtMs = Date.parse(resp?.data?.expiresAt);
	if (Number.isNaN(expiresAtMs)) {
		return fallbackSeconds;
	}

	const serverNowMs = serverNowFrom(resp);
	const nowMs = serverNowMs && !Number.isNaN(serverNowMs) ? serverNowMs : Date.now();

	return Math.max(0, Math.ceil((expiresAtMs - nowMs) / 1000));
};

export const NAFATH_TRANSACTION_TIMEOUT_SECONDS = 180;

export const NafathFailure = {
	activeTransaction: 'activeTransaction',
	requestFailed: 'requestFailed',
};

export const nafathFailureFrom = (err) =>
	err?.response?.data?.NafathActiveTransaction
		? NafathFailure.activeTransaction
		: NafathFailure.requestFailed;

export const nafathMessageKey = (failure, isExistingTransaction) => {
	if (failure === NafathFailure.activeTransaction) {
		return 'nafathActiveTransaction';
	}
	if (failure === NafathFailure.requestFailed) {
		return 'nafathRequestFailed';
	}
	return isExistingTransaction ? 'nafathExistingTransaction' : null;
};
